/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AuditChallenge
 */
export interface AuditChallenge {
  /**
   *
   * @type {string}
   * @memberof AuditChallenge
   */
  challengeId: string;
  /**
   *
   * @type {string}
   * @memberof AuditChallenge
   */
  subject: string;
  /**
   * The challenge email as sent, verbatim. Showing a reworded version
   * would put a second statement of our position in front of them.
   *
   * @type {string}
   * @memberof AuditChallenge
   */
  body: string;
  /**
   *
   * @type {string}
   * @memberof AuditChallenge
   */
  sentAt?: string;
  /**
   *
   * @type {string}
   * @memberof AuditChallenge
   */
  sentBy?: string;
}

/**
 * Check if a given object implements the AuditChallenge interface.
 */
export function instanceOfAuditChallenge(
  value: object,
): value is AuditChallenge {
  if (!("challengeId" in value) || value["challengeId"] === undefined)
    return false;
  if (!("subject" in value) || value["subject"] === undefined) return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  return true;
}

export function AuditChallengeFromJSON(json: any): AuditChallenge {
  return AuditChallengeFromJSONTyped(json, false);
}

export function AuditChallengeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuditChallenge {
  if (json == null) {
    return json;
  }
  return {
    challengeId: json["challengeId"],
    subject: json["subject"],
    body: json["body"],
    sentAt: json["sentAt"] == null ? undefined : json["sentAt"],
    sentBy: json["sentBy"] == null ? undefined : json["sentBy"],
  };
}

export function AuditChallengeToJSON(json: any): AuditChallenge {
  return AuditChallengeToJSONTyped(json, false);
}

export function AuditChallengeToJSONTyped(
  value?: AuditChallenge | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    challengeId: value["challengeId"],
    subject: value["subject"],
    body: value["body"],
    sentAt: value["sentAt"],
    sentBy: value["sentBy"],
  };
}
